import React, { useState } from 'react';
import { pushHomeToolEvent } from '../utils/dataLayerEvents';

export default function EmailModal({ isOpen, onClose, onSessionReset, generatorKw, allElectricKw, appliances }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle', 'submitting', 'success', 'error'
  const [errorMessage, setErrorMessage] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setErrorMessage('Please enter your name');
      setStatus('error');
      return;
    }

    if (!email) {
      setErrorMessage('Please enter your email address');
      setStatus('error');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrorMessage('Please enter a valid email address');
      setStatus('error');
      return;
    }

    const generatorKwValue = Number(generatorKw.toFixed(2));

    setStatus('submitting');
    setErrorMessage('');

    try {
      const response = await fetch('/wp-json/wlion/v1/interactive-home-tool/email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          generator_kw: generatorKw,
          all_electric_kw: allElectricKw,
          appliances,
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {

      pushHomeToolEvent('home_tool_email_submit_success', {
        generator_kw: generatorKwValue,
      });
        setStatus('success');
        setTimeout(() => {
          setName('');
          setEmail('');
          setStatus('idle');
          onClose();
          if (onSessionReset) {
            onSessionReset();
          }
        }, 2000);
      } else {
        setErrorMessage(data.message || 'Failed to send email. Please try again.');
        setStatus('error');
      }
    } catch (error) {
      console.error('Email submission error:', error);
      setErrorMessage('Failed to send email. Please try again.');
      setStatus('error');
    }
  };

  const handleClose = () => {
    if (status !== 'submitting') {
      setName('');
      setEmail('');
      setStatus('idle');
      setErrorMessage('');
      onClose();
    }
  };

  return (
    <div className="iht-modal-overlay" onClick={handleClose}>
      <div className="iht-modal" onClick={(e) => e.stopPropagation()}>
        <button className="iht-modal-close" onClick={handleClose} disabled={status === 'submitting'}>
          &times;
        </button>

        <h2 className="iht-modal-title">
          Turn these insights into your next power play
        </h2>
        <p className="iht-modal-subtitle">
          Email your results to reference as you plan your next project.
        </p>

        {status === 'success' ? (
          <div className="iht-modal-success">
            <p>Your results have been sent!</p>
            <p>Check your inbox shortly.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="iht-modal-form">
            <div className="iht-form-group">
              <label htmlFor="iht-name">Name</label>
              <input
                type="text"
                id="iht-name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your full name"
                disabled={status === 'submitting'}
              />
            </div>

            <div className="iht-form-group">
              <label htmlFor="iht-email">Email</label>
              <input
                type="email"
                id="iht-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                disabled={status === 'submitting'}
              />
            </div>

            {status === 'error' && (
              <div className="iht-modal-error">
                {errorMessage}
              </div>
            )}

            <button
              type="submit"
              className="iht-modal-submit"
              disabled={status === 'submitting'}
            >
              {status === 'submitting' ? 'SENDING...' : 'SUBMIT'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
